import WisetackPromo from './WisetackPromo'

export * from './WisetackPromo'
export default WisetackPromo
